export default __webpack_public_path__ + "static/media/gp-dropdown.d381f9b7.webp";